// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false;

Vue.prototype.getSyncImage=function(dom,src){
  var img=new Image(),
      that=this,
      isReady=false,
      minTime=500, //最小时长，以便于有动画效果
      checkReady=function(){
        if(isReady){
          ready();
        }
        else{
          isReady=true;
        }
      },
      ready=function(){
        that._loadingImg=null;
        dom.classList.remove("bg-loading");
        dom.classList.add("bg-loading-anim");
        dom.offsetHeight;
        dom.classList.add("bg-fade-in");
        dom.style.backgroundImage="url('"+src+"')";
        dom.classList.remove("bg-loading-anim");
      };

  if(this._loadingImg){
    this._loadingImg.onload=this._loadingImg.onerror=null;
    clearTimeout(this._loadingTimer);
  }
 
  this._loadingImg=img;
   dom.style.backgroundImage=null;
   dom.classList.remove("bg-fade-in");
   dom.classList.add("bg-loading");

   this._loadingTimer=setTimeout(checkReady,minTime);
   img.onload=img.onerror=checkReady;
   img.src=src;
};

Vue.prototype.getBackground=function(src){
  var out="background-image:url('";
      out+=src;
      out+="');";

      return out;
};


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js